module.exports = __webpack_public_path__ + "img/role.455ff9c6.svg";